import React from "react"
import "./Interests.css";
export default function Interests(){
   return(
       <main>
            <h1 className="interests"><b>Interests</b></h1>
            <ul className="interests-list">
                <li>Volleyball, badminton, hiking, camping</li>
                <li>3D & 2D CAD Designs</li>
                <li>3D-printing, photography, dancing</li>
            </ul>
       </main>
   )
}